import React, { useContext, useEffect, useReducer } from 'react'
import { Context } from '../../../context/app-context'
import ModalLogin from '../../molecules/modalLogin/modalLogin'
import GenericModal from '../../templates/generic-modal/generic-modal'
import ModalDoublePoints from '../../molecules/modalDoublePoints/modalDoublePoints'
import ModalSorry from '../../molecules/modalSorry/modalSorry'
import ModalKeys from '../../molecules/modalKeys/modalKeys'
import ModalTalk from '../../molecules/modalTalk/modalTalk'
import ModalTerms from '../../molecules/modalTerms/modalTerms'

const INITIAL_MODAL_STATE = null

const validateModal = (currentState, action) => {
  if (action && typeof action.type === 'string') {
    const modalProps = action?.props || {}
    const modalsList = {
      login: <ModalLogin {...modalProps} />,
      double: <ModalDoublePoints {...modalProps} />,
      sorry: <ModalSorry {...modalProps} />,
      keys: <ModalKeys {...modalProps} />,
      talk: <ModalTalk {...modalProps} />,
      terms: <ModalTerms {...modalProps} />,
    }

    return modalsList[action.type]
  }
  return null
}

export default function ModalViewer() {
  const [modal, setModal] = useReducer(validateModal, INITIAL_MODAL_STATE)
  const { modalActive } = useContext(Context)

  useEffect(() => {
    setModal(modalActive)
    document.body.style.overflow = !!modalActive ? 'hidden' : 'initial'

    return () => {
      document.body.style.overflow = 'initial'
      setModal(null)
    }
  }, [modalActive])
  return (
    modal && (
      <GenericModal {...(modalActive?.wrapperProps || {})}>
        {modal}
      </GenericModal>
    )
  )
}
